import { Chip } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import HandshakeIcon from "@mui/icons-material/Handshake";
import BusinessIcon from "@mui/icons-material/Business";
import GroupsIcon from "@mui/icons-material/Groups";
import type { AttachmentKind } from "../hooks/useAutoAttach";

interface Props {
  kind: AttachmentKind;
  label: string;
  onDismiss?: () => void;
}

const ICONS: Record<AttachmentKind, React.ReactElement> = {
  person: <PersonIcon fontSize="small" />,
  deal: <HandshakeIcon fontSize="small" />,
  organization: <BusinessIcon fontSize="small" />,
  partner: <GroupsIcon fontSize="small" />,
};

const KIND_LABELS: Record<AttachmentKind, string> = {
  person: "Person",
  deal: "Deal",
  organization: "Organization",
  partner: "Partner",
};

export function AttachmentChip({ kind, label, onDismiss }: Props) {
  return (
    <Chip
      size="small"
      icon={ICONS[kind]}
      label={`${KIND_LABELS[kind]}: ${label}`}
      onDelete={onDismiss}
      variant="outlined"
      sx={{ alignSelf: "flex-start", mb: 0.5 }}
    />
  );
}
